const ua = {
  common: {
    home: "Головна",
    aboutBrand: "Про бренд",
    contactUs: "Звʼязатися з нами",
    products: "Продукти",
  },

  home: {
    title: "VALMIS DE LUXE",
    subtitle: "Лідер ринку рибних консервів України",
    contactUs: "Зв'язатися",
    aboutBrand: "Про бренд",
  },

  footer: {
    contact: "Контакти",
    newsletterTitle: "Не втрачайте можливість співпраці",
    emailPlaceholder: "Електронна пошта",
    contactUs: "Звʼязатися з нами",
    copyright: "© 2026 Valmis. Усі права захищено",
  },

  contact: {
  title: "Звʼяжіться з нами",
  subtitle: "Ми раді почути потенційних партнерів.",

  name: "Повне ім’я *",
  company: "Компанія",
  email: "Електронна пошта *",
  phone: "Номер телефону",
  message: "Ваше повідомлення",

  submit: "Надіслати повідомлення",

  success: "Повідомлення надіслано!",
  error: "Не вдалося надіслати. Спробуйте ще раз.",

  purpose: {
    partnership: "Партнерство",
    supply: "Пропозиція постачання",
    distribution: "Дистрибуція",
    general: "Загальне питання",
  },
},

about: {
  hero: {
    title: "VALMIS DE LUXE",
    subtitle: "Лідер ринку рибних консервів України",
  },

  achievements: {
    title: "Наші досягнення",
    item1: "Найбільший імпортер рибних консервів в Україні",
    item2: "Широка присутність у національних мережах та серед дистриб’юторів",
    item3: "Бездоганна репутація серед партнерів і клієнтів",
  },

  mission: {
    title: "Наша місія",
    text: () => (
      <>
        Забезпечувати <strong>доступні</strong> та
        <strong className="highlight-text"> високоякісні продукти</strong>,
        зберігаючи <strong>традиції</strong> і впроваджуючи сучасні технології.
      </>
    ),
  },

  products: {
    title: "Продукти та бренди",
    subtitle: "Ми імпортуємо понад 40 видів консервованої продукції:",
    list: () => (
                <>
                  🐟 Рибні консерви з Балтії 🇪🇪🇱🇻🇱🇹 <br />
                  🍍 Консервовані фрукти з Таїланду 🇹🇭 <br />
                  🥩 М’ясні консерви з Польщі 🇵🇱 <br />
                  🫒 Оливки з Іспанії 🇪🇸
                </>
              ),
    brands: "Наші бренди:",
  },

  video: {
    title: "Це виглядає DE LUXE",
    subtitle: "Відчуйте смак традицій у кожному шматочку",
    muted: "Вимкнути звук",
    unmuted: "Увімкнути звук"
  },

  testimonials: {
    title: "Відгуки клієнтів",
    subtitle: () => (
                <>
                  Тільки найкраще <br /> для наших клієнтів
                </>
              ),
    text1: "VALMIS DE LUXE — найкращий постачальник, з яким ми працювали.",
    text2: "Висока якість продукції та завжди вчасні поставки.",
  },

  advantages: {
    title: "Наші переваги",
    item1: "15 років на ринку — надійний партнер",
    item2: "100% виконання замовлень",
    item3: "Швидка обробка та доставка",
    item4: "Індивідуальний підхід до кожного клієнта",
  },

  cooperation: {
    text: "Ми цінуємо наших партнерів та відкриті до довгострокової взаємовигідної співпраці!",
  },
},

juice: {
  title: "Сік",
  products: {
    lemon: {
      title: "Сік лимона (Приправа)\nLemoni",
      weight: "220 мл | Пляшка",
      description: "Фасовка: 15 шт | 156 ящ/палет",
    },
    lime: {
      title: "Сік лайма (Приправа)\nLemoni",
      weight: "220 мл | Пляшка",
      description: "Фасовка: 15 шт | 156 ящ/палет",
    },
  },
},

pineapple: {
  title: "Ананаси",
  products: {
    valmisRings: {
      title: "Ананаси кільцями в сиропі\nVALMIS",
      weight: "580 мл | Ж/б банка",
      description: "Фасовка: 24 шт | 45 ящ/палет",
    },
    valmisChunks: {
      title: "Ананаси шматочками в сиропі\nVALMIS",
      weight: "580 мл | Ж/б банка",
      description: "Фасовка: 24 шт | 45 ящ/палет",
    },
    ananasoffRings: {
      title: "Ананаси кільцями в сиропі\nANANASOFF",
      weight: "580 мл | Ж/б банка",
      description: "Фасовка: 24 шт | 45 ящ/палет",
    },
    ananasoffChunks: {
      title: "Ананаси шматочками в сиропі\nANANASOFF",
      weight: "580 мл | Ж/б банка",
      description: "Фасовка: 24 шт | 45 ящ/палет",
    },
  },
},

vegetables: {
  title: "Консервовані овочі",

  olives: {
    title: "Оливки",
    description: "Маслини та оливки Olive Land у жерстяних банках.",
  },

  cucumbers: {
    title: "Огірки",
    description: "Мариновані корнішони та огірки VALMIS у скляних банках.",
  },

  tomatoPaste: {
    title: "Томатна паста",
    description: "Томатна паста VALMIS 25% у скляній банці.",
  },

  products: {
    olives: {
      black425: {
        title: "Маслини без кісточки\nOlive Land",
        weight: "425 мл | Ж/б банка",
        description: "Фасовка: 12 шт | 144 ящ/палет",
      },
      black300: {
        title: "Маслини без кісточки\nOlive Land",
        weight: "300 мл | Ж/б банка",
        description: "Фасовка: 12 шт | 196 ящ/палет",
      },
      green300: {
        title: "Оливки без кісточки\nOlive Land",
        weight: "300 мл | Ж/б банка",
        description: "Фасовка: 12 шт | 196 ящ/палет",
      },
    },

    cucumbers: {
      cornichons480: {
        title: "Огірки корнішони мариновані (3-6 см)\nVALMIS",
        weight: "500 мл (480 г) | Скляна банка",
        description: "Фасовка: 12 шт/ящ (гофроящик) | 70 ящ/палет",
      },
      cornichons680: {
        title: "Огірки корнішони мариновані (3-6 см)\nVALMIS",
        weight: "720 мл (680 г) | Скляна банка",
        description: "Фасовка: 12 шт/ящ (гофроящик) | 56 ящ/палет",
      },
      gherkins680: {
        title: "Огірки мариновані Gherkins (6-9 см)\nVALMIS",
        weight: "720 мл (680 г) | Скляна банка",
        description: "Фасовка: 12 шт/ящ (гофроящик) | 56 ящ/палет",
      },
    },

    tomatoPaste: {
      valmis25_460: {
        title: "Паста томатна 25%\nVALMIS",
        weight: "460 г | Скляна банка",
        description: "Фасовка: 8 шт/ящ (термоплівка) | 126 ящ/палет",
      },
    },
  },
},

tuna: {
  title: "Тунець",
  products: {
    valmisWholeOil: {
      title: "Тунець цілий в олії\nVALMIS DE LUXE",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },
    valmisWholeBrine: {
      title: "Тунець цілий у власному соку\nVALMIS DE LUXE",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },
    valmisSaladOil: {
      title: "Тунець салатний в олії\nVALMIS",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },
    valmisSaladBrine: {
      title: "Тунець салатний у власному соку\nVALMIS",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },

    tuncoffWholeOil: {
      title: "Тунець цілий в олії\nТУНЦОFF",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },
    tuncoffWholeBrine: {
      title: "Тунець цілий у власному соку\nТУНЦОFF",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },
    tuncoffSaladOil: {
      title: "Тунець салатний в олії\nТУНЦОFF",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },
    tuncoffSaladBrine: {
      title: "Тунець салатний у власному соку\nТУНЦОFF",
      weight: "150 г | Ж/б банка",
      description: "Фасовка: 24 шт | 150 ящ/палет",
    },
  },
},

canned: {
  title: "Консерви",

  sprats: {
    title: "Шпроти",
    description: "Класичні ризькі, по-гданськи, DeLuxe.",
  },

  atlantic: {
    title: "Атлантика",
    description: "Скумбрія, сардини, горбуша, сьомга.",
  },

  tomato: {
    title: "Томатна група",
    description: "Кілька, сардини, скумбрія в томаті.",
  },

  liver: {
    title: "Печінка тріски",
    description: "Premium, TL та класичні формати.",
  },
},

sprats: {
  title: "Шпроти",

  products: {

    sprats_valmis_deluxe_tl_240: {
      title: "Шпроти в олії (DeLuxe, TL)\nVALMIS",
      weight: "240 г | Ж/б TL",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },

    valmis_deluxe_glass_250: {
      title: "Шпроти в олії (DeLuxe, скло)\nVALMIS",
      weight: "250 г | Скляна банка",
      description: "Фасовка: 12 шт | 144 ящ/палет",
    },

    valmis_gdansk_170: {
      title: "Шпроти в олії по-гданськи\nVALMIS",
      weight: "170 г | Ключ",
      description: "Фасовка: 28 шт | 128 ящ/палет",
    },

    valmis_riga_160: {
      title: "Ризькі шпроти в олії\nVALMIS",
      weight: "160 г | Ключ",
      description: "Фасовка: 36 шт | 96 ящ/палет",
    },

    valmis_riga_240: {
      title: "Ризькі шпроти в олії\nVALMIS",
      weight: "240 г | Ключ",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },

    ventspils_160: {
      title: "Шпроти в олії\nVentspils",
      weight: "160 г | Ключ",
      description: "Фасовка: 36 шт | 96 ящ/палет",
    },

    ventspils_240: {
      title: "Шпроти в олії\nVentspils",
      weight: "240 г | Ключ",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },

    ventspils_tl_240: {
      title: "Шпроти в олії\nVentspils",
      weight: "240 г | Ж/б TL",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },

    ventspils_190: {
      title: "Шпроти в олії\nVentspils",
      weight: "190 г | Ключ",
      description: "Фасовка: 36 шт | 85 ящ/палет",
    },
  },
},


atlantic: {
  title: "Атлантика",

  products: {
    valmis_sardine_oil_240: {
      title: "Сардина в олії\nVALMIS DeLuxe",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    valmis_mackerel_oil_240: {
      title: "Скумбрія в олії\nVALMIS DeLuxe",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    valmis_pink_salmon_natural_240: {
      title: "Горбуша натуральна\nVALMIS DeLuxe",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    valmis_salmon_juice_240: {
      title: "Сьомга у власному соку\nVALMIS",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },

    baltic_riga_sardine_oil_240: {
      title: "Сардина ризька в олії\nBaltic Sea",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    ventspils_riga_sardine_oil_240: {
      title: "Сардина ризька в олії\nVentspils",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    ventspils_mackerel_oil_240: {
      title: "Скумбрія атлантична в олії\nVentspils",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    ventspils_pink_salmon_natural_240: {
      title: "Горбуша натуральна\nVentspils",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
  },
},

tomato: {
  title: "Томатна група",

  products: {
    valmis_kilka_fried_240: {
      title: "Кілька обсмажена в томатному соусі\nVALMIS DeLuxe",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    valmis_chopped_fish_240: {
      title: "Риба рубана в томатному соусі\nVALMIS",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },

    ventspils_riga_sardine_240: {
      title: "Сардина ризька в томатному соусі\nVentspils",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    ventspils_mackerel_240: {
      title: "Скумбрія в томатному соусі\nVentspils",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    ventspils_chopped_fish_240: {
      title: "Риба рубана в томатному соусі\nVentspils",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    ventspils_kilka_fried_240: {
      title: "Кілька обсмажена в томатному соусі\nVentspils",
      weight: "240 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    ventspils_kilka_fried_190: {
      title: "Кілька обсмажена в томатному соусі\nVentspils",
      weight: "190 г | Ж/б банка",
      description: "Фасовка: 36 шт | 85 ящ/палет",
    },
  },
},

liver: {
  title: "Печінка тріски",

  products: {
    valmis_tl_230: {
      title: "Печінка тріски (TL)\nVALMIS DeLuxe",
      weight: "230 г | Ж/б TL",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    valmis_121: {
      title: "Печінка тріски\nVALMIS DeLuxe",
      weight: "121 г | Ж/б банка",
      description: "Фасовка: 12 шт | 391 ящ/палет",
    },
    valmis_tl_115: {
      title: "Печінка тріски (TL)\nVALMIS DeLuxe",
      weight: "115 г | Ж/б TL",
      description: "Фасовка: 12 шт | 391 ящ/палет",
    },
    valmis_230: {
      title: "Печінка тріски\nVALMIS DeLuxe",
      weight: "230 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },

    baltic_230: {
      title: "Печінка тріски\nBaltic Sea PREMIUM",
      weight: "230 г | Ж/б банка",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    baltic_tl_230: {
      title: "Печінка тріски (TL)\nBaltic Sea PREMIUM",
      weight: "230 г | Ж/б TL",
      description: "Фасовка: 24 шт | 96 ящ/палет",
    },
    baltic_121: {
      title: "Печінка тріски\nBaltic Sea PREMIUM",
      weight: "121 г | Ж/б банка",
      description: "Фасовка: 12 шт | 391 ящ/палет",
    },
  },
},


};

export default ua;
